import React from "react";
import ScrollableAnchor from "react-scrollable-anchor";
import BigCalendar from 'react-big-calendar'
import moment from 'moment'
import 'moment/locale/de';

class CalendarSection extends React.Component {

    state = {
        courses: [
            {
                id: 0,
                title: 'Rehasport + Online (Level 1)',
                start: moment().startOf('week').add(0, 'd').hour(18).toDate(),
                end: moment().startOf('week').add(0, 'd').hour(18).minute(45).toDate(),
                color: '#021f5e'
            },
            {
               id: 1,
               title: 'Rehasport (Level 2)',
               start: moment().startOf('week').add(0, 'd').hour(19).minute(15).toDate(),
               end: moment().startOf('week').add(0, 'd').hour(20).minute(0).toDate(),
                color: '#021f5e'
             },
            {
               id: 2,
               title: 'Rehasport + Online (Level 1)',
               start: moment().startOf('week').add(1, 'd').hour(9).toDate(),
               end: moment().startOf('week').add(1, 'd').hour(9).minute(45).toDate(),
                color: '#021f5e'
             },
            {
               id: 3,
               title: 'Rehasport (Level 1)',
               start: moment().startOf('week').add(1, 'd').hour(10).minute(15).toDate(),
               end: moment().startOf('week').add(1, 'd').hour(11).minute(0).toDate(),
                color: '#021f5e'
            },
            {
                id: 16,
                title: 'Rehasport (Level 1)',
                start: moment().startOf('week').add(1, 'd').hour(16).minute(45).toDate(),
                end: moment().startOf('week').add(1, 'd').hour(17).minute(30).toDate(),
                color: '#021f5e'
            },
            {
                id: 4,
                title: 'Rehasport (Level 2)',
                start: moment().startOf('week').add(1, 'd').hour(18).minute(0).toDate(),
                end: moment().startOf('week').add(1, 'd').hour(18).minute(45).toDate(),
                color: '#021f5e'
            },
            {
                id: 5,
                title: 'Rehasport (Level 1)',
                start: moment().startOf('week').add(1, 'd').hour(19).minute(15).toDate(),
                end: moment().startOf('week').add(1, 'd').hour(20).minute(0).toDate(),
                color: '#021f5e'
            },
            {
                id: 6,
                title: 'Rehasport (Level 1)',
                start: moment().startOf('week').add(2, 'd').hour(9).toDate(),
                end: moment().startOf('week').add(2, 'd').hour(9).minute(45).toDate(),
                color: '#021f5e'
            },
            {
                id: 7,
                title: 'Rehasport + Online (Qi Gong)',
                start: moment().startOf('week').add(2, 'd').hour(18).toDate(),
                end: moment().startOf('week').add(2, 'd').hour(18).minute(45).toDate(),
                color: '#021f5e'
            },
            {
                id: 8,
                title: 'Rehasport (Achtsamkeit)',
                start: moment().startOf('week').add(2, 'd').hour(19).minute(15).toDate(),
                end: moment().startOf('week').add(2, 'd').hour(20).minute(0).toDate(),
                color: '#021f5e'
            },
            {
                id: 9,
                title: 'Rehasport + Online (Level 1)',
                start: moment().startOf('week').add(3, 'd').hour(9).toDate(),
                end: moment().startOf('week').add(3, 'd').hour(9).minute(45).toDate(),
                color: '#021f5e'
            },
            {
                id: 10,
                title: 'Rehasport (Level 1)',
                start: moment().startOf('week').add(3, 'd').hour(10).minute(15).toDate(),
                end: moment().startOf('week').add(3, 'd').hour(11).minute(0).toDate(),
                color: '#021f5e'
            },
            {
                id: 11,
                title: 'Rehasport (Level 1)',
                start: moment().startOf('week').add(3, 'd').hour(18).toDate(),
                end: moment().startOf('week').add(3, 'd').hour(18).minute(45).toDate(),
                color: '#021f5e'
            },
            {
                id: 12,
                title: 'Rehasport (Level 2)',
                start: moment().startOf('week').add(3, 'd').hour(19).minute(15).toDate(),
                end: moment().startOf('week').add(3, 'd').hour(20).minute(0).toDate(),
                color: '#021f5e'
            },
            {
                id: 13,
                title: 'Hapkido (Kinderkampfkunst)',
                start: moment().startOf('week').add(4, 'd').hour(16).toDate(),
                end: moment().startOf('week').add(4, 'd').hour(17).minute(30).toDate(),
                color: '#bf901f'
            },
            {
                id: 14,
                title: 'Rehasport (Betreuung)',
                start: moment().startOf('week').add(1, 'd').hour(12).toDate(),
                end: moment().startOf('week').add(1, 'd').hour(14).minute(0).toDate(),
                color: '#ffff36',
                fontColor: "#000000"
            },
            {
                id: 15,
                title: 'Rehasport (Betreuung)',
                start: moment().startOf('week').add(3, 'd').hour(16).toDate(),
                end: moment().startOf('week').add(3, 'd').hour(17).minute(30).toDate(),
                color: '#ffff36',
                fontColor: "#000000"
            }
        ],
        dialogOpen: false
    };

    eventStyleGetter = function(event, start, end, isSelected) {
        var style = {
            backgroundColor: event.color,
            borderRadius: '0px',
            opacity: 0.8,
            color: event.fontColor,
            border: '0px',
            display: 'block'
        };
        return {
            style: style
        };
    };

    render = () => {
        moment.locale('de', {
            week: {
                dow: 1,
                doy: 1
            }
        });
        var localizer = BigCalendar.momentLocalizer(moment);

        const minTime = new Date();
        minTime.setHours(9,0,0);
        const maxTime = new Date();
        maxTime.setHours(21,0,0);

        return <ScrollableAnchor id="courses">
            <section className="content-section bg-dark text-white text-center animatedParent animateOnce" data-appear-top-offset='-300' data-sequence='500'>
                <div className="container">
                    <div className="content-section-heading">
                        <h3 className="text-secondary mb-0">Kalender</h3>
                        <h2 className="mb-5">Wann finden die Kurse statt</h2>
                    </div>

                    <div className="calendarBackground">
                        <BigCalendar
                          {...this.props}
                          localizer={localizer}
                          style={{ height: 1000 }}
                          events={this.state.courses}
                          defaultDate={new Date()}
                          startAccessor="start"
                          endAccessor="end"
                          defaultView='week'
                          min = {minTime}
                          max = {maxTime}
                          onDrillDown={null}
                          toolbar={false}
                          eventPropGetter={this.eventStyleGetter}
                          timeslots={1}
                        />
                        <div align="left">
                            <h5>Legende:</h5>
                            <ul>
                               <li><span style={{backgroundColor: '#021f5e', color: 'white'}}>Rehasport</span></li>
                                <li><span style={{backgroundColor: '#bf901f'}}>Hapkido (Kinder Kampfkunst)</span></li>
                                <li><span style={{backgroundColor: '#ffff36', color: 'black'}}>Rehasport (Bertreuung)</span></li>
                            </ul>

                        </div>
                    </div>
                </div>
            </section>
        </ScrollableAnchor>

    }
}
export default CalendarSection;



// WEBPACK FOOTER //
// ./src/main/calendar.js